/* global PhotoSwipeLightbox, PhotoSwipe */

export default class PhotoSwipeTheme {
	constructor(gallery) {
		if (!gallery) return;

		const lightbox = new PhotoSwipeLightbox({
			// bgOpacity: 0.2,
			gallery: gallery,
			children: 'a',
			pswpModule: PhotoSwipe
		});

		lightbox.on('uiRegister', function() {
			lightbox.pswp.ui.registerElement({
				name: 'custom-caption',
				order: 9,
				isButton: false,
				appendTo: 'root',
				html: 'Caption text',
				onInit: (el) => {
					lightbox.pswp.on('change', () => {
						const currSlideElement = lightbox.pswp.currSlide.data.element;
						let captionHTML = '';
						if (currSlideElement) {
							var capElement = currSlideElement.querySelector('.hidden-caption-content');
							captionHTML = capElement && capElement.textContent ? capElement.textContent : '';
						}
						el.innerHTML = captionHTML || '';
					});
				}
			});
		});

		lightbox.init();
	}
}
